import { render, staticRenderFns } from "./registerProblems.vue?vue&type=template&id=4f8b4927&scoped=true"
import script from "./registerProblems.vue?vue&type=script&lang=js"
export * from "./registerProblems.vue?vue&type=script&lang=js"
import style0 from "./registerProblems.vue?vue&type=style&index=0&id=4f8b4927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b4927",
  null
  
)

export default component.exports